/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AiUsageCompanyLimitModel } from '../../models/ai-usage-company-limit-model';

export interface GetCompanyLimit$Params {
  clientID?: number;
}

export function GetCompanyLimit(http: HttpClient, rootUrl: string, params?: GetCompanyLimit$Params, context?: HttpContext): Observable<StrictHttpResponse<AiUsageCompanyLimitModel>> {
  const rb = new RequestBuilder(rootUrl, GetCompanyLimit.PATH, 'get');
  if (params) {
    rb.query('clientID', params.clientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AiUsageCompanyLimitModel>;
    })
  );
}

GetCompanyLimit.PATH = '/api/AIUsage/GetCompanyLimit';
